/*
 * @Author: Src
 * @Date: 2025-07-16 09:53:33
 * @LastEditTime: 2026-06-05 14:25:06
 * @LastEditors: Src
 * @FilePath: /work-station/src/common/enum/carSpu.ts
 * @Description: 二手车相关字段
 */
export enum ECarSPUField {
  ID = 'id',
  NAME = 'name', // 商品名称
  FIRST_REGISTRATION_DATE = 'firstRegistrationDate', // 首次上牌日期
  MILEAGE = 'mileage', // 里程
  CAR_LOCATION = 'carLocation', // 车辆所在地
  TRANSFER_TIMES = 'transferTimes', // 过户次数
  USE_TO = 'useTo', // 用途：1-家用，2-营转非，3-单位用
  COLOR = 'color', // 颜色
  INTERIOR_COLOR = 'interiorColor', // 内饰颜色
  HIGHLIGHTS = 'highlights', // 亮点
  DESCRIPTION = 'description', // 描述
  PRICE = 'price', // 价格
  CERTIFICATE_INFO = 'certificateInfo', // 登记证情况：1-齐全，2-丢失，3-补办中
  MAINTENANCE_INFO = 'maintenanceInfo', // 保养情况：1-4s店定期保养，2-非4s店定期保养，3-无定期保养
  EXTERIOR_INFO = 'exteriorInfo', // 外观成色：1-极新，2-较新，3-一般，4-较差
  INTERIOR_INFO = 'interiorInfo', // 内饰情况：1-完好，2-有破损
  ACCIDENT_INFO = 'accidentInfo', // 事故情况：1-无事故，2-有轻微剐蹭，3-有过大修
  SELLING_POINT = 'sellingPoint', // 销售卖点
  SEQUENCE = 'sequence', // 排序
  AUDIT_STATUS = 'auditStatus', // 审核状态：0-未审核，1-已审核
  ONLINE = 'online', // 线上状态：0-未上架，1-已上架
  IS_DEL = 'isDel', // 删除状态：0-未删除，1-已删除
  GEAR_NAME = 'gearName', // 变速箱类型
  LITER = 'liter', // 排量
  VIN_CODE = 'vinCode', // VIN码
  CAR_IMAGES = 'carImages', // 车辆图片
  VERIFICATION_IMAGES = 'verificationImages', // 车辆图片
  HEADER_IMAGE = 'headerImage', // 头部图片

  CAR_DIMENSIONS = 'car_dimensions',
  CAR_COMPARTMENT_TYPE = 'car_compartment_type', // 车厢形式
  MAX_TOTAL_MASS = 'max_total_mass', // kg 最大总质量
  WHEELBASE = 'wheelbase', // 轴距 mm
  SHAFTS_NUMBER = 'shafts_number', // 轴数

  REFIT_CHARGE = 'refitCharge', // 加装价格
  EVALUATION_PRICE = 'evaluationPrice', // 评估价格
  MANAGER_PRICE = 'managerPrice', // 经理底价
  SELLER_PRICE = 'sellerPrice', // 销售底价
  OFFICIAL_PRICE = 'officialPrice', // 官方价格
  CAR_KEY = 'carKey', // 钥匙数量
  CAR_SOURCE = 'carSource', // 采购类型
  CAR_PURCHASER = 'carPurchaser', // 车辆采购员
  CAR_PURCHASE_DATE = 'carPurchaseDate', // 采购时间
  PURCHASE_PRICE = 'purchasePrice', // 采购价
  VALUER = 'valuer', // 评估师
  PROCURE_PROOF = 'procureProof', // 采购凭证（资源ID）
  TRAFFIC_INSURANCE_DATE = 'trafficInsuranceDate', // 交强险到期日期
  COMMERCIAL_INSURANCE_DATE = 'commercialInsuranceDate', // 商业险到期日期


  VEHICLE_SOURCE_PROCEDURE_INFORMATION = 'vehicleSourceProcedureInformation', // 车源手续信息  模块字段 仅模块展示使用
  VEHICLE_SOURCE_INFORMATION = 'vehicleSourceInformation', // 车源情况息  模块字段 仅模块展示使用
  VEHICLE_SOURCE_PRICE_INFORMATION = 'vehicleSourcePriceInformation', // 车源价格信息  模块字段 仅模块展示使用
  INFORMATION_ON_THE_LOCATION_OF_THE_VEHICLE_SOURCE = 'informationOnTheLocationOfTheVehicleSource', // 车源所在地信息  模块字段 仅模块展示使用
  LICENSE_INFORMATION_MODULE = 'licenseInformationModule', // 牌证信息
  BRAND_CAR_SERIES_MODELS = 'brandCarSeriesModels', // 品牌车系车型
  // DESCRIPTION = 'description', // 车源车况信息  模块字段 仅模块展示使用
  AUTOMATIC_SHELVING = 'automaticShelving', // 自动上架
  AUTOMATIC_SHELVING_TIME = 'automaticShelvingTime', // 自动上架时间
  AUTOMATIC_DELISTING = 'automaticDelisting', // 自动下架
  AUTOMATIC_DELISTING_TIME = 'automaticDelistingTime', // 自动下架时间
}


export enum EVehicleOperations {
  CID = 'cid',
  IMAGES = 'images',
  NAME = 'name',
  MARKET_PRICE = 'market_price',
  PRICE = 'price',
  TAGS = 'tags',
  V_RANK = 'v_rank',
  DESCRIPTION = 'description',
}
